<div class="asset-detail-container">

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
        <!-- Header Skeleton -->
        <div class="asset-main-header card-style">
            <div class="asset-title-row">
                <div class="asset-identity">
                    <p-skeleton shape="circle" size="3rem"></p-skeleton>
                    <div class="asset-title-content">
                        <p-skeleton height="2rem" width="70%" class="mb-2"></p-skeleton>
                        <p-skeleton height="1rem" width="50%"></p-skeleton>
                    </div>
                </div>
                <div class="asset-status-section">
                    <p-skeleton height="2rem" width="100px" borderRadius="20px"></p-skeleton>
                    <p-skeleton height="1.5rem" width="80px" borderRadius="12px"></p-skeleton>
                </div>
            </div>
        </div>

        <!-- Grid Skeleton -->
        <div class="asset-details-grid card-style">
            <div class="asset-detail-section" *ngFor="let section of [1,2,3,4]">
                <div class="section-header">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <p-skeleton height="1rem" width="120px"></p-skeleton>
                </div>
                <div class="section-content">
                    <div *ngFor="let item of [1,2,3,4,5]" class="spec-item">
                        <p-skeleton height="0.9rem" width="60px"></p-skeleton>
                        <p-skeleton height="0.9rem" width="80px"></p-skeleton>
                    </div>
                </div>
            </div>
        </div>

        <!-- Audit Skeleton -->
        <div class="asset-audit-info card-style">
            <div class="audit-header">
                <p-skeleton shape="circle" size="2rem"></p-skeleton>
                <p-skeleton height="1rem" width="150px"></p-skeleton>
            </div>
            <div class="audit-grid">
                <div class="audit-item" *ngFor="let item of [1,2,3]">
                    <p-skeleton height="0.8rem" width="100px" class="mb-1"></p-skeleton>
                    <p-skeleton height="0.9rem" width="140px"></p-skeleton>
                </div>
            </div>
        </div>
    </div>

    <!-- Content State -->
    <div *ngIf="!loading && asset">
        <!-- Header Principal del Activo -->
        <div class="asset-main-header card-style">
            <div class="asset-title-row">
                <div class="asset-identity">
                    <div class="asset-icon" [ngClass]="'category-' + (asset.category.toLowerCase() || 'default')">
                        <i class="fas fa-truck" *ngIf="asset.category === 'Vehiculos'"></i>
                        <i class="fas fa-cogs" *ngIf="asset.category !== 'Vehiculos'"></i>
                    </div>
                    <div class="asset-title-content">
                        <h1 class="asset-main-title">
                            {{asset.name}}
                        </h1>
                    </div>
                </div>
                <div class="asset-actions">
                    <p-button label="Editar" icon="pi pi-pencil" [outlined]="true" severity="primary"
                        [loading]="editLoading" (onClick)="editAsset()">
                    </p-button>
                </div>
            </div>

            <div class="asset-status-row">
                <div class="asset-status-badge"
                    [ngClass]="'status-' + (asset.status.toLowerCase().replace(' ', '-') || 'default')">
                    <i class="fas fa-circle"></i>
                    {{asset.status}}
                </div>
                <div class="lease-badge-info">
                    <span class="lease-badge" [ngClass]="asset.lease ? 'lease-active' : 'lease-inactive'"
                        *ngIf="asset.lease">
                        <i class="fas fa-handshake"></i>
                        Arrendamiento: {{asset.lease}}
                    </span>
                    <span class="lease-badge lease-inactive" *ngIf="!asset.lease">
                        <i class="fas fa-clock"></i>
                        Sin asignar a arrendamiento
                    </span>
                </div>
            </div>
        </div>

        <!-- Grid de Detalles (3 Columnas) -->
        <div class="asset-details-grid card-style">

            <!-- Especificaciones Técnicas -->
            <div class="asset-detail-section">
                <div class="section-header">
                    <div class="section-icon icon-specifications">
                        <i class="fas fa-cog"></i>
                    </div>
                    <h3 class="section-title">Especificaciones</h3>
                </div>
                <div class="section-content">
                    <div class="spec-item">
                        <span class="spec-label">Modelo:</span>
                        <span class="spec-value" [ngClass]="asset.assetModel ? 'field-complete' : 'field-empty'">
                            {{asset.assetModel || 'Sin especificar'}}
                        </span>
                    </div>
                    <div class="spec-item">
                        <span class="spec-label">Versión:</span>
                        <span class="spec-value" [ngClass]="asset.version ? 'field-complete' : 'field-empty'">
                            {{asset.version || 'Sin especificar'}}
                        </span>
                    </div>
                    <div class="spec-item">
                        <span class="spec-label">Color:</span>
                        <span class="spec-value" [ngClass]="asset.color ? 'field-complete' : 'field-empty'">
                            {{asset.color || 'Sin especificar'}}
                        </span>
                    </div>
                    <div class="spec-item">
                        <span class="spec-label">Serie:</span>
                        <span class="spec-value" [ngClass]="asset.serie ? 'field-complete' : 'field-empty'">
                            {{asset.serie || 'N/A'}}
                        </span>
                    </div>
                    <div class="spec-item">
                        <span class="spec-label">Motor:</span>
                        <span class="spec-value" [ngClass]="asset.engineNumber ? 'field-complete' : 'field-empty'">
                            {{asset.engineNumber || 'N/A'}}
                        </span>
                    </div>
                    <div class="spec-item">
                        <span class="spec-label">Placas/VRN:</span>
                        <span class="spec-value" [ngClass]="asset.acquisition.vrn ? 'field-complete' : 'field-empty'">
                            {{asset.acquisition.vrn || 'N/A'}}
                        </span>
                    </div>
                    <div class="spec-item">
                        <span class="spec-label">Fecha Entrega:</span>
                        <span class="spec-value">
                            <span *ngIf="asset.delivery.date" class="field-complete">{{asset.delivery.date |
                                date:'dd-MM-yyyy'}}</span>
                            <span *ngIf="!asset.delivery.date" class="field-empty">No entregado</span>
                        </span>
                    </div>
                    <div class="document-item" [ngClass]="asset.delivery.proof ? 'document-available' : 'document-missing'"
                         (click)="asset.delivery.proof ? downloadDocument(asset.delivery.proof, 'delivery-proof') : null">
                        <i class="fas fa-truck document-icon icon-purple"></i>
                        <span class="document-name">Comprobante de Entrega</span>
                        <span class="document-status"
                            [ngClass]="asset.delivery.proof ? 'available' : 'missing'">
                            {{asset.delivery.proof ? 'Disponible' : 'Faltante'}}
                        </span>
                    </div>
                </div>
            </div>

            <!-- Información Financiera -->
            <div class="asset-detail-section">
                <div class="section-header">
                    <div class="section-icon icon-financial">
                        <i class="fas fa-dollar-sign"></i>
                    </div>
                    <h3 class="section-title">Información Financiera</h3>
                </div>
                <div class="section-content">
                    <div class="financial-breakdown">
                        <div class="financial-group">
                            <div class="group-title">Adquisición</div>
                            <div class="financial-row">
                                <span class="row-label">Subtotal:</span>
                                <span class="row-value">{{asset.acquisition.amount |
                                    currency:'symbol':'1.0-0'}}</span>
                            </div>
                            <div class="financial-row">
                                <span class="row-label">IVA:</span>
                                <span class="row-value">{{asset.acquisition.iva |
                                    currency:'symbol':'1.0-0'}}</span>
                            </div>
                            <div class="financial-row">
                                <span class="row-label">Total:</span>
                                <span class="row-value highlight">{{asset.acquisition.total |
                                    currency:'symbol':'1.0-0'}}</span>
                            </div>
                        </div>

                        <div class="financial-group">
                            <div class="group-title">Valor de Venta</div>
                            <div *ngIf="asset.saleValue?.amount; else noSaleValue">
                                <div class="financial-row">
                                    <span class="row-label">Subtotal:</span>
                                    <span class="row-value">{{asset.saleValue.amount |
                                        currency:'symbol':'1.0-0'}}</span>
                                </div>
                                <div class="financial-row">
                                    <span class="row-label">IVA:</span>
                                    <span class="row-value">{{asset.saleValue.iva |
                                        currency:'symbol':'1.0-0'}}</span>
                                </div>
                                <div class="financial-row">
                                    <span class="row-label">Total:</span>
                                    <span class="row-value highlight">{{asset.saleValue.total |
                                        currency:'symbol':'1.0-0'}}</span>
                                </div>
                            </div>
                            <ng-template #noSaleValue>
                                <div class="financial-row">
                                    <span class="row-label field-empty">Sin definir:</span>
                                    <span class="row-value field-empty">Valor no establecido</span>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Documentación -->
            <div class="asset-detail-section">
                <div class="section-header">
                    <div class="section-icon icon-documentation">
                        <i class="fas fa-file-alt"></i>
                    </div>
                    <h3 class="section-title">Documentación</h3>
                </div>
                <div class="section-content">
                    <div class="documents-list">
                        <div class="document-item"
                            [ngClass]="asset.acquisition.paymentProof ? 'document-available' : 'document-missing'"
                            (click)="asset.acquisition.paymentProof ? downloadDocument(asset.acquisition.paymentProof, 'payment-proof') : null">
                            <i class="fas fa-receipt document-icon icon-blue"></i>
                            <span class="document-name">Comprobante de Pago</span>
                            <span class="document-status"
                                [ngClass]="asset.acquisition.paymentProof ? 'available' : 'missing'">
                                {{asset.acquisition.paymentProof ? 'Disponible' : 'Faltante'}}
                            </span>
                        </div>

                        <div class="document-item"
                            [ngClass]="asset.acquisition.invoicePdf ? 'document-available' : 'document-missing'"
                            (click)="asset.acquisition.invoicePdf ? downloadDocument(asset.acquisition.invoicePdf, 'invoice-pdf') : null">
                            <i class="fas fa-file-pdf document-icon icon-red"></i>
                            <span class="document-name">Factura PDF</span>
                            <span class="document-status"
                                [ngClass]="asset.acquisition.invoicePdf ? 'available' : 'missing'">
                                {{asset.acquisition.invoicePdf ? 'Disponible' : 'Faltante'}}
                            </span>
                        </div>

                        <div class="document-item"
                            [ngClass]="asset.acquisition.invoiceXml ? 'document-available' : 'document-missing'"
                            (click)="asset.acquisition.invoiceXml ? downloadDocument(asset.acquisition.invoiceXml, 'invoice-xml') : null">
                            <i class="fas fa-code document-icon icon-purple"></i>
                            <span class="document-name">Factura XML</span>
                            <span class="document-status"
                                [ngClass]="asset.acquisition.invoiceXml ? 'available' : 'missing'">
                                {{asset.acquisition.invoiceXml ? 'Disponible' : 'Faltante'}}
                            </span>
                        </div>

                        <div class="document-item"
                            [ngClass]="asset.acquisition.circulationCard ? 'document-available' : 'document-missing'"
                            (click)="asset.acquisition.circulationCard ? downloadDocument(asset.acquisition.circulationCard, 'circulation-card') : null">
                            <i class="fas fa-id-card document-icon icon-green"></i>
                            <span class="document-name">Tarjeta Circulación</span>
                            <span class="document-status"
                                [ngClass]="asset.acquisition.circulationCard ? 'available' : 'missing'">
                                {{asset.acquisition.circulationCard ? 'Disponible' : 'Faltante'}}
                            </span>
                        </div>

                        <div class="document-item"
                            [ngClass]="asset.acquisition.inssurancePolice ? 'document-available' : 'document-missing'"
                            (click)="asset.acquisition.inssurancePolice ? downloadDocument(asset.acquisition.inssurancePolice, 'insurance-police') : null">
                            <i class="fas fa-shield-alt document-icon icon-orange"></i>
                            <span class="document-name">Póliza Seguro</span>
                            <span class="document-status"
                                [ngClass]="asset.acquisition.inssurancePolice ? 'available' : 'missing'">
                                {{asset.acquisition.inssurancePolice ? 'Disponible' : 'Faltante'}}
                            </span>
                        </div>

                        <div class="document-item"
                            [ngClass]="asset.acquisition.gps ? 'document-available' : 'document-missing'"
                            (click)="asset.acquisition.gps ? downloadDocument(asset.acquisition.gps, 'gps') : null">
                            <i class="fas fa-map-marker-alt document-icon icon-red"></i>
                            <span class="document-name">GPS</span>
                            <span class="document-status" [ngClass]="asset.acquisition.gps ? 'available' : 'missing'">
                                {{asset.acquisition.gps ? 'Disponible' : 'Faltante'}}
                            </span>
                        </div>

                        <div class="document-item"
                            [ngClass]="asset.acquisition.permisson ? 'document-available' : 'document-missing'"
                            (click)="asset.acquisition.permisson ? downloadDocument(asset.acquisition.permisson, 'permisson') : null">
                            <i class="fas fa-file-signature document-icon icon-violet"></i>
                            <span class="document-name">Permisos</span>
                            <span class="document-status"
                                [ngClass]="asset.acquisition.permisson ? 'available' : 'missing'">
                                {{asset.acquisition.permisson ? 'Disponible' : 'Faltante'}}
                            </span>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Información del Proveedor -->
            <div class="asset-detail-section">
                <div class="section-header">
                    <div class="section-icon icon-provider">
                        <i class="fas fa-building"></i>
                    </div>
                    <h3 class="section-title">Proveedor</h3>
                </div>
                <div class="section-content">
                    <div *ngIf="isProvider(asset.provider); else noProvider">
                        <div class="spec-item">
                            <span class="spec-label">Nombre:</span>
                            <span class="spec-value field-complete">{{asset.provider.fullName}}</span>
                        </div>
                        <div class="spec-item">
                            <span class="spec-label">RFC:</span>
                            <span class="spec-value field-complete">{{asset.provider.rfc}}</span>
                        </div>
                        <div class="spec-item">
                            <span class="spec-label">Sector:</span>
                            <span class="spec-value field-complete">{{asset.provider.sector}}</span>
                        </div>
                        <div class="spec-item">
                            <span class="spec-label">Subsector:</span>
                            <span class="spec-value field-complete">{{asset.provider.subSector}}</span>
                        </div>
                        <div class="spec-item">
                            <span class="spec-label">Estado:</span>
                            <span class="spec-value"
                                [ngClass]="asset.provider.status === 'ACTIVE' ? 'field-complete' : 'field-warning'">
                                {{asset.provider.status === 'ACTIVE' ? 'Activo' : asset.provider.status}}
                            </span>
                        </div>
                        <div class="spec-item">
                            <span class="spec-label">Registrado:</span>
                            <span class="spec-value field-complete">{{asset.provider.createdAt | date:'dd MMM
                                yyyy'}}</span>
                        </div>
                    </div>
                    <ng-template #noProvider>
                        <div class="spec-item">
                            <span class="spec-label field-empty">Sin proveedor:</span>
                            <span class="spec-value field-empty">No asignado</span>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>

        <!-- Información de Auditoría -->
        <div class="asset-audit-info card-style">
            <div class="audit-header">
                <div class="audit-icon">
                    <i class="fas fa-history"></i>
                </div>
                <h3 class="audit-title">Información del Sistema</h3>
            </div>
            <div class="audit-grid">
                <div class="audit-item">
                    <span class="audit-label">Creado:</span>
                    <span class="audit-value">{{asset.createdAt | date:'dd MMM yyyy, HH:mm'}}</span>
                </div>
                <div class="audit-item">
                    <span class="audit-label">Última actualización:</span>
                    <span class="audit-value">{{asset.updatedAt | date:'dd MMM yyyy, HH:mm'}}</span>
                </div>
                <div class="audit-item" *ngIf="asset.banker">
                    <span class="audit-label">Banquero asignado:</span>
                    <span class="audit-value">{{getBankerName()}}</span>
                </div>
            </div>
        </div>

    </div> <!-- End Content State -->

</div>

<!-- Modal de Edición -->
<p-dialog [(visible)]="showEditModal" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true"
    [maximizable]="false" styleClass="asset-edit-modal" (onHide)="onModalHide()">

    <!-- Header del Modal -->
    <ng-template pTemplate="header">
        <div class="modal-header-content">
            <div class="header-info">
                <h2 class="modal-title">
                    <i class="fas fa-edit"></i>
                    Editar Información del Activo
                </h2>
                <p class="modal-subtitle" *ngIf="asset">
                    {{asset.brand}} {{asset.assetModel}} {{asset.version}}
                </p>
            </div>
        </div>
    </ng-template>

    <!-- Contenido del Modal -->
    <div class="modal-content-enhanced" [formGroup]="editForm" *ngIf="editForm">

        <!-- Loading State -->
        <div *ngIf="modalLoading" class="loading-overlay">
            <p-progressSpinner></p-progressSpinner>
            <p>Guardando información...</p>
        </div>

        <!-- Formulario Enhanced con Sistema de Tarjetas -->
        <div class="edit-form-enhanced">

            <!-- Sección 1: Información Básica -->
            <div class="form-card">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-info-circle"></i>
                        Información Básica
                    </h3>
                </div>
                <div class="card-content">
                    <div class="form-grid">
                        <div class="form-field">
                            <label for="name" class="field-label required">Nombre del Activo</label>
                            <input pInputText id="name" formControlName="name" placeholder="Nombre completo del activo"
                                class="form-control">
                            <small *ngIf="editForm.get('name')?.invalid && editForm.get('name')?.touched"
                                class="error-message">
                                El nombre es requerido (mínimo 3 caracteres)
                            </small>
                        </div>

                        <div class="form-field">
                            <label for="category" class="field-label required">Categoría</label>
                            <p-dropdown id="category" formControlName="category" [options]="[
                  { label: 'Vehiculos', value: 'Vehiculos' },
                  { label: 'Tecnología', value: 'Tecnología' },
                  { label: 'Maquinaria', value: 'Maquinaria' },
                  { label: 'Inmuebles', value: 'Inmuebles' },
                  { label: 'Otros', value: 'Otros' }
                ]" optionLabel="label" optionValue="value" placeholder="Seleccione una categoría" [showClear]="true"
                                scrollHeight="150px" class="form-control">
                            </p-dropdown>
                            <small *ngIf="editForm.get('category')?.invalid && editForm.get('category')?.touched"
                                class="error-message">
                                La categoría es requerida
                            </small>
                        </div>

                        <div class="form-field">
                            <label for="brand" class="field-label required">Marca</label>
                            <input pInputText id="brand" formControlName="brand" placeholder="Marca del activo"
                                class="form-control">
                            <small *ngIf="editForm.get('brand')?.invalid && editForm.get('brand')?.touched"
                                class="error-message">
                                La marca es requerida
                            </small>
                        </div>

                        <div class="form-field">
                            <label for="assetModel" class="field-label required">Modelo</label>
                            <input pInputText id="assetModel" formControlName="assetModel"
                                placeholder="Modelo del activo" class="form-control">
                            <small *ngIf="editForm.get('assetModel')?.invalid && editForm.get('assetModel')?.touched"
                                class="error-message">
                                El modelo es requerido
                            </small>
                        </div>

                        <div class="form-field">
                            <label for="version" class="field-label required">Versión</label>
                            <input pInputText id="version" formControlName="version" placeholder="Versión del activo"
                                class="form-control">
                            <small *ngIf="editForm.get('version')?.invalid && editForm.get('version')?.touched"
                                class="error-message">
                                La versión es requerida
                            </small>
                        </div>

                        <div class="form-field">
                            <label for="color" class="field-label required">Color</label>
                            <input pInputText id="color" formControlName="color" placeholder="Color del activo"
                                class="form-control">
                            <small *ngIf="editForm.get('color')?.invalid && editForm.get('color')?.touched"
                                class="error-message">
                                El color es requerido (solo letras)
                            </small>
                        </div>
                    </div>

                    <div class="form-field full-width mt-3">
                        <label for="description" class="field-label required">Descripción</label>
                        <textarea pInputTextarea id="description" formControlName="description"
                            placeholder="Descripción detallada del activo" class="form-control" rows="3">
            </textarea>
                        <small *ngIf="editForm.get('description')?.invalid && editForm.get('description')?.touched"
                            class="error-message">
                            La descripción es requerida
                        </small>
                    </div>
                </div>
            </div>

            <!-- Sección 2: Especificaciones Técnicas -->
            <div class="form-card">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-cogs"></i>
                        Especificaciones Técnicas
                    </h3>
                </div>
                <div class="card-content">
                    <div class="form-grid">
                        <div class="form-field">
                            <label for="serie" class="field-label required">Número de Serie</label>
                            <input pInputText id="serie" formControlName="serie"
                                placeholder="Número de serie del activo" class="form-control">
                            <small *ngIf="editForm.get('serie')?.invalid && editForm.get('serie')?.touched"
                                class="error-message">
                                El número de serie es requerido
                            </small>
                        </div>

                        <div class="form-field">
                            <label for="engineNumber" class="field-label">Número de Motor</label>
                            <input pInputText id="engineNumber" formControlName="engineNumber"
                                placeholder="Número de motor (opcional)" class="form-control">
                            <small class="field-help">
                                Campo opcional para vehículos y maquinaria
                            </small>
                        </div>
                        
                        <div formGroupName="acquisition" class="form-field">
                            <label for="vrn" class="field-label">Placas/VRN</label>
                            <input pInputText id="vrn" formControlName="vrn"
                                placeholder="Número de placas (opcional)" class="form-control">
                            <small class="field-help">
                                Número de placas o VRN del vehículo (opcional)
                            </small>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sección 3: Información Financiera -->
            <div class="form-card">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-dollar-sign"></i>
                        Información Financiera
                    </h3>
                </div>
                <div class="card-content">
                    <div formGroupName="acquisition">
                        <div class="financial-section">
                            <h4 class="subsection-title">Adquisición</h4>
                            <div class="form-grid">
                                <div class="form-field">
                                    <label for="acquisitionAmount" class="field-label required">Subtotal</label>
                                    <p-inputNumber id="acquisitionAmount" formControlName="amount" mode="currency"
                                        currency="USD" locale="en-US" placeholder="0.00" class="form-control">
                                    </p-inputNumber>
                                    <small
                                        *ngIf="editForm.get('acquisition.amount')?.invalid && editForm.get('acquisition.amount')?.touched"
                                        class="error-message">
                                        El subtotal es requerido y debe ser positivo
                                    </small>
                                </div>

                                <div class="form-field">
                                    <label for="acquisitionIva" class="field-label required">IVA</label>
                                    <p-inputNumber id="acquisitionIva" formControlName="iva" mode="currency"
                                        currency="USD" locale="en-US" placeholder="0.00" class="form-control">
                                    </p-inputNumber>
                                    <small
                                        *ngIf="editForm.get('acquisition.iva')?.invalid && editForm.get('acquisition.iva')?.touched"
                                        class="error-message">
                                        El IVA es requerido y debe ser positivo
                                    </small>
                                </div>

                                <div class="form-field">
                                    <label for="acquisitionTotal" class="field-label">Total (Calculado)</label>
                                    <p-inputNumber id="acquisitionTotal" formControlName="total" mode="currency"
                                        currency="USD" locale="en-US"
                                        class="form-control calculated-field">
                                    </p-inputNumber>
                                    <small class="field-help mb-3">
                                        Se calcula automáticamente: Subtotal + IVA
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Proveedor - fuera del grupo acquisition -->
                    <div class="financial-section">
                        <h4 class="subsection-title">Proveedor</h4>
                        <div class="form-grid">
                            <div class="form-field">
                                <label for="provider" class="field-label required">Proveedor</label>
                                <p-dropdown id="provider" formControlName="provider" [options]="providers"
                                    optionLabel="label" optionValue="value" placeholder="Seleccione un proveedor"
                                    [showClear]="true" scrollHeight="150px" class="form-control">
                                </p-dropdown>
                                <small
                                    *ngIf="editForm.get('provider')?.invalid && editForm.get('provider')?.touched"
                                    class="error-message">
                                    El proveedor es requerido
                                </small>
                                <small class="field-help">
                                    Seleccione el proveedor del activo
                                </small>
                            </div>
                        </div>
                    </div>

                    <div formGroupName="saleValue">
                        <div class="financial-section">
                            <h4 class="subsection-title">Valor de Venta (Opcional)</h4>
                            <div class="form-grid">
                                <div class="form-field">
                                    <label for="saleAmount" class="field-label">Subtotal Venta</label>
                                    <p-inputNumber id="saleAmount" formControlName="amount" mode="currency"
                                        currency="USD" locale="en-US" placeholder="0.00" class="form-control">
                                    </p-inputNumber>
                                </div>

                                <div class="form-field">
                                    <label for="saleIva" class="field-label">IVA Venta</label>
                                    <p-inputNumber id="saleIva" formControlName="iva" mode="currency" currency="USD"
                                        locale="en-US" placeholder="0.00" class="form-control">
                                    </p-inputNumber>
                                </div>

                                <div class="form-field">
                                    <label for="saleTotal" class="field-label">Total Venta (Calculado)</label>
                                    <p-inputNumber id="saleTotal" formControlName="total" mode="currency" currency="USD"
                                        locale="en-US" class="form-control calculated-field">
                                    </p-inputNumber>
                                    <small class="field-help">
                                        Se calcula automáticamente cuando se ingresan valores
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sección 4: Documentación de Adquisición -->
            <div class="form-card">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-file-alt"></i>
                        Documentación de Adquisición
                    </h3>
                </div>
                <div class="card-content">
                    <div class="form-grid">
                        <div formGroupName="acquisition" class="form-field">
                            <app-input-single-file 
                                label="Comprobante de Pago"
                                (fileUrl)="onFileSelected($event, 'paymentProof', 'acquisition')"
                                (fileDeleted)="onFileDeleted('paymentProof', 'acquisition')"
                                (downloadRequested)="onDownloadRequested($event, 'comprobante_pago')"
                                [tooltip]="'Comprobante de pago de la adquisición del activo'"
                                [documentName]="'paymentProof'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('acquisition.paymentProof')?.value">
                            </app-input-single-file>
                        </div>

                        <div formGroupName="acquisition" class="form-field">
                            <app-input-single-file 
                                label="Factura PDF"
                                (fileUrl)="onFileSelected($event, 'invoicePdf', 'acquisition')"
                                (fileDeleted)="onFileDeleted('invoicePdf', 'acquisition')"
                                (downloadRequested)="onDownloadRequested($event, 'factura_pdf')"
                                [tooltip]="'Factura del activo en formato PDF'"
                                [documentName]="'invoicePdf'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('acquisition.invoicePdf')?.value">
                            </app-input-single-file>
                        </div>

                        <div formGroupName="acquisition" class="form-field">
                            <app-input-single-file 
                                label="Factura XML"
                                (fileUrl)="onFileSelected($event, 'invoiceXml', 'acquisition')"
                                (fileDeleted)="onFileDeleted('invoiceXml', 'acquisition')"
                                (downloadRequested)="onDownloadRequested($event, 'factura_xml')"
                                [tooltip]="'Factura del activo en formato XML'"
                                [documentName]="'invoiceXml'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('acquisition.invoiceXml')?.value">
                            </app-input-single-file>
                        </div>

                        <div formGroupName="acquisition" class="form-field">
                            <app-input-single-file 
                                label="Tarjeta de Circulación"
                                (fileUrl)="onFileSelected($event, 'circulationCard', 'acquisition')"
                                (fileDeleted)="onFileDeleted('circulationCard', 'acquisition')"
                                (downloadRequested)="onDownloadRequested($event, 'tarjeta_circulacion')"
                                [tooltip]="'Fotografía de la tarjeta de circulación del vehículo'"
                                [documentName]="'circulationCard'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('acquisition.circulationCard')?.value">
                            </app-input-single-file>
                        </div>

                        <div formGroupName="acquisition" class="form-field">
                            <app-input-single-file 
                                label="Permisos"
                                (fileUrl)="onFileSelected($event, 'permisson', 'acquisition')"
                                (fileDeleted)="onFileDeleted('permisson', 'acquisition')"
                                (downloadRequested)="onDownloadRequested($event, 'permisos')"
                                [tooltip]="'Permisos legales y documentación oficial'"
                                [documentName]="'permisson'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('acquisition.permisson')?.value">
                            </app-input-single-file>
                        </div>

                        <div formGroupName="acquisition" class="form-field">
                            <app-input-single-file 
                                label="Póliza de Seguro"
                                (fileUrl)="onFileSelected($event, 'inssurancePolice', 'acquisition')"
                                (fileDeleted)="onFileDeleted('inssurancePolice', 'acquisition')"
                                (downloadRequested)="onDownloadRequested($event, 'poliza_seguro')"
                                [tooltip]="'Póliza de seguro del activo'"
                                [documentName]="'inssurancePolice'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('acquisition.inssurancePolice')?.value">
                            </app-input-single-file>
                        </div>

                        <div formGroupName="acquisition" class="form-field">
                            <app-input-single-file 
                                label="GPS"
                                (fileUrl)="onFileSelected($event, 'gps', 'acquisition')"
                                (fileDeleted)="onFileDeleted('gps', 'acquisition')"
                                (downloadRequested)="onDownloadRequested($event, 'gps_documento')"
                                [tooltip]="'Documentación del sistema GPS del activo'"
                                [documentName]="'gps'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('acquisition.gps')?.value">
                            </app-input-single-file>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sección 5: Fechas y Entregas -->
            <div class="form-card">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-calendar"></i>
                        Fechas y Entregas
                    </h3>
                </div>
                <div class="card-content">
                    <div class="form-grid">
                        <div formGroupName="acquisition" class="form-field">
                            <label for="acquisitionDate" class="field-label">Fecha de Adquisición</label>
                            <p-calendar id="acquisitionDate" formControlName="date" [showIcon]="true"
                                placeholder="Seleccione fecha (opcional)" dateFormat="dd/mm/yy" [showClear]="true"
                                [showButtonBar]="true" [readonlyInput]="false" appendTo="body" class="form-control">
                            </p-calendar>
                            <small class="field-help">
                                Fecha de adquisición del activo (opcional)
                            </small>
                        </div>

                        <div formGroupName="delivery" class="form-field">
                            <label for="deliveryDate" class="field-label">Fecha de Entrega</label>
                            <p-calendar id="deliveryDate" formControlName="date" [showIcon]="true"
                                placeholder="Seleccione fecha (opcional)" dateFormat="dd/mm/yy" [showClear]="true"
                                [showButtonBar]="true" [readonlyInput]="false" appendTo="body" class="form-control">
                            </p-calendar>
                            <small class="field-help">
                                Fecha de entrega al cliente (opcional)
                            </small>
                        </div>

                        <div formGroupName="delivery" class="form-field">
                            <app-input-single-file 
                                label="Comprobante de Entrega"
                                (fileUrl)="onFileSelected($event, 'proof', 'delivery')"
                                (fileDeleted)="onFileDeleted('proof', 'delivery')"
                                (downloadRequested)="onDownloadRequested($event, 'comprobante_entrega')"
                                [tooltip]="'Comprobante de entrega del activo al cliente'"
                                [documentName]="'proof'"
                                [folder]="'assets'"
                                [id]="id"
                                [fileUrlValue]="editForm.get('delivery.proof')?.value">
                            </app-input-single-file>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- Footer del Modal -->
    <ng-template pTemplate="footer">
        <div class="modal-footer">
            <div class="action-buttons">
                <p-button label="Cancelar" (onClick)="closeEditModal()" styleClass="p-button-text"
                    [disabled]="modalLoading">
                </p-button>

                <p-button icon="pi pi-save" label="Guardar Cambios" (onClick)="saveAssetChanges()"
                    [loading]="modalLoading" [disabled]="modalLoading || !editForm.valid" styleClass="p-button-primary">
                </p-button>
            </div>
        </div>
    </ng-template>
</p-dialog>